import {
    useMemo,
} from 'react'
import useEnumValues from 'app/hooks/useEnumValues'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'

import {
    OperationalHour,
} from '../../serviceCenters.types'
import getFields from './operationalDays.fields'
import useStyles from './operationalDays.style'

const OperationalDays = ({
    value,
    onChange,
}: {
    value: OperationalHour,
    onChange: (val: OperationalHour) => void,
}) => {
    const {
        classes,
    } = useStyles()

    const allowedValues = useEnumValues()

    const fields = useMemo(() => {
        return getFields(allowedValues, value.isOperational)
    }, [
        allowedValues,
        value.isOperational,
    ])

    return (
        <DomainObjectForm
            fields={fields}
            value={value}
            onChange={onChange}
            name={`OperationalDay-${value.dayOfWeek}`}
            wrapper="simple"
            className={classes.gridWrapper}
        />
    )
}

export default OperationalDays
